import React from 'react';

import styles from './disclaimer.module.scss';
import useScreenMode from '../../../hooks/useScreenMode';
import { DESKTOP } from '../../constants';

const Disclaimer = () => {
  const screenMode = useScreenMode();
  return (
    <>
      <p className={styles.disclaimer}>
        FabFitFun is a subscription service that is billed $49.99 USD each season or $179.99 USD annually for 4 boxes,
        plus
        {' '}
        <a href={`${process.env.REACT_APP_SUPPORT_URL}/articles/360035608872-Will-I-be-charged-sales-tax-`}>taxes</a>
        {' '}
        and shipping, if applicable.
        You will be automatically charged using the payment method provided.
        Foreign exchange or transaction fees may apply for non US customers.
        Shipping charges of $8 USD per box applies for shipping to Canada,
        Hawaii, Alaska and Puerto Rico ($10 USD for the UK).
        You may cancel your membership at any time online or by contacting FabFitFun Support
        {' '}
        <a href={`${process.env.REACT_APP_SUPPORT_URL}/requests/new`}>here</a>
        .
        For more details,
        {' '}
        <a href={`${process.env.REACT_APP_SUPPORT_URL}/articles/360035968991-What-s-your-cancellation-policy-`}>
          click here
        </a>
        .
      </p>
      <p className={styles.disclaimer}>
        By
        {' '}
        {screenMode === DESKTOP ? 'clicking' : 'tapping'}
        {' '}
        ‘Confirm Purchase’ you are agreeing to our
        {' '}
        <a href={`${process.env.REACT_APP_LEGAL_URL}/#terms-of-use`}>Terms of Use and Sale</a>
        {' '}
        and
        {' '}
        <a href={`${process.env.REACT_APP_LEGAL_URL}/#box-membership-terms`}>FabFitFun Membership Terms</a>
        .
      </p>
    </>
  );
};

export default Disclaimer;
